/* Rideau Rempart, le guide en vrai livre : double page, la page de droite tourne autour de la reliure. Desktop uniquement, mobile inchangé. */
(function () {
  var book = document.querySelector('.rrg__book');
  if (!book || book.dataset.rrfb) return;
  book.dataset.rrfb = '1';
  var leaves = [].slice.call(book.querySelectorAll('.rrg__leaf'));
  var radios = [].slice.call(book.querySelectorAll('.rrg__radio'));
  if (leaves.length < 2 || radios.length !== leaves.length) return;
  var mq = window.matchMedia('(min-width: 900px)');
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var N = leaves.length;

  function clean(node) {
    var c = node.cloneNode(true);
    [].forEach.call(c.querySelectorAll('[aria-labelledby]'), function (el) {
      var ids = el.getAttribute('aria-labelledby').split(/\s+/);
      var txt = ids.map(function (id) { var t = document.getElementById(id); return t ? t.textContent.trim() : ''; }).join('. ');
      el.removeAttribute('aria-labelledby');
      if (txt) el.setAttribute('aria-label', txt);
    });
    [].forEach.call(c.querySelectorAll('[id]'), function (el) { el.removeAttribute('id'); });
    return c;
  }
  var L = [], R = [];
  leaves.forEach(function (leaf) {
    var sp = leaf.querySelector('.rrg__spread');
    var kids = sp ? [].slice.call(sp.children) : [leaf];
    L.push(kids[0]);
    R.push(kids[1] || kids[0]);
  });
  function fill(pageEl, side, i) {
    var inn = pageEl.querySelector('.rrfb__in');
    inn.innerHTML = '';
    inn.appendChild(clean(side === 'l' ? L[i] : R[i]));
  }
  function makePage(side) {
    var p = document.createElement('div');
    p.className = 'rrfb__page rrfb__page--' + side;
    p.innerHTML = '<div class="rrfb__in"></div>';
    return p;
  }

  var root = document.createElement('div');
  root.className = 'rrfb';
  root.setAttribute('tabindex', '0');
  root.setAttribute('aria-label', 'Livre : utilisez les flèches gauche et droite pour tourner les pages');
  root.innerHTML =
    '<div class="rrfb__book">' +
      '<div class="rrfb__drop rrfb__drop--r"></div><div class="rrfb__drop rrfb__drop--l"></div>' +
      '<div class="rrfb__corner rrfb__corner--l" aria-hidden="true"></div>' +
      '<div class="rrfb__corner rrfb__corner--r" aria-hidden="true"></div>' +
    '</div>' +
    '<div class="rrfb__bar">' +
      '<button type="button" class="rrfb__btn" data-prev aria-label="Page précédente"><svg class="rr-glyph" viewBox="0 0 24 24" aria-hidden="true" focusable="false" style="overflow:visible"><text class="material-symbols-outlined notranslate" translate="no" x="12" y="12" text-anchor="middle" dominant-baseline="central" style="font-size:24px;fill:currentColor;stroke:none">arrow_back</text></svg></button>' +
      '<span class="rrfb__count" aria-live="polite"></span>' +
      '<button type="button" class="rrfb__btn" data-next aria-label="Tourner la page"><svg class="rr-glyph" viewBox="0 0 24 24" aria-hidden="true" focusable="false" style="overflow:visible"><text class="material-symbols-outlined notranslate" translate="no" x="12" y="12" text-anchor="middle" dominant-baseline="central" style="font-size:24px;fill:currentColor;stroke:none">arrow_forward</text></svg></button>' +
    '</div>';
  var bk = root.querySelector('.rrfb__book');
  var pl = makePage('l'), pr = makePage('r');
  bk.insertBefore(pr, bk.firstChild);
  bk.insertBefore(pl, bk.firstChild);
  var dropR = bk.querySelector('.rrfb__drop--r'), dropL = bk.querySelector('.rrfb__drop--l');
  var cornerR = bk.querySelector('.rrfb__corner--r'), cornerL = bk.querySelector('.rrfb__corner--l');
  var btnPrev = root.querySelector('[data-prev]'), btnNext = root.querySelector('[data-next]');
  var count = root.querySelector('.rrfb__count');
  var stack = book.querySelector('.rrg__stack');
  stack.parentNode.insertBefore(root, stack.nextSibling);
  var cur = Math.max(0, radios.findIndex(function (r) { return r.checked; }));

  function showSpread(i) {
    fill(pl, 'l', i); fill(pr, 'r', i);
    cur = i;
    btnPrev.disabled = i === 0; btnNext.disabled = i === N - 1;
    cornerL.hidden = i === 0; cornerR.hidden = i === N - 1;
    count.textContent = 'Page ' + (i + 1) + ' sur ' + N;
  }

  function measure() {
    if (!mq.matches) return;
    var w = bk.clientWidth / 2;
    var probe = makePage('r');
    probe.style.cssText = 'position:absolute;visibility:hidden;left:-9999px;top:0;bottom:auto;height:auto;width:' + w + 'px';
    var inn = probe.querySelector('.rrfb__in');
    inn.style.position = 'relative';
    book.appendChild(probe);
    var h = 0;
    for (var i = 0; i < N; i++) {
      ['l', 'r'].forEach(function (s) {
        probe.className = 'rrfb__page rrfb__page--' + s;
        inn.innerHTML = '';
        inn.appendChild(clean(s === 'l' ? L[i] : R[i]));
        h = Math.max(h, inn.offsetHeight);
      });
    }
    probe.remove();
    bk.style.setProperty('--fb-h', Math.ceil(h + 30) + 'px');
  }

  var sheet = null, dir = 0, target = 0, angle = 0, raf = 0;
  function buildSheet(d, to) {
    dir = d; target = to;
    sheet = document.createElement('div');
    sheet.className = 'rrfb__sheet rrfb__sheet--' + (d > 0 ? 'next' : 'prev');
    sheet.setAttribute('aria-hidden', 'true');
    var front = document.createElement('div'); front.className = 'rrfb__face rrfb__face--front';
    var back = document.createElement('div'); back.className = 'rrfb__face rrfb__face--back';
    var pf = makePage(d > 0 ? 'r' : 'l'), pb = makePage(d > 0 ? 'l' : 'r');
    fill(pf, d > 0 ? 'r' : 'l', cur);
    fill(pb, d > 0 ? 'l' : 'r', to);
    front.appendChild(pf); back.appendChild(pb);
    [front, back].forEach(function (f) { var s = document.createElement('div'); s.className = 'rrfb__shade'; f.appendChild(s); });
    sheet.appendChild(front); sheet.appendChild(back);
    bk.appendChild(sheet);
    if (d > 0) fill(pr, 'r', to); else fill(pl, 'l', to);
    bk.classList.add('is-busy');
  }
  function render(p) {
    angle = p;
    var deg = (dir > 0 ? -180 : 180) * p;
    var lift = Math.sin(Math.PI * p);
    sheet.style.transform = 'rotateY(' + deg + 'deg) translateZ(' + (lift * 2) + 'px)';
    sheet.querySelector('.rrfb__face--front .rrfb__shade').style.opacity = Math.min(1, p * 2.2);
    sheet.querySelector('.rrfb__face--back .rrfb__shade').style.opacity = Math.min(1, (1 - p) * 2.2);
    (dir > 0 ? dropR : dropL).style.opacity = p < .5 ? lift * .9 : 0;
    (dir > 0 ? dropL : dropR).style.opacity = p >= .5 ? lift * .7 : 0;
    sheet.style.boxShadow = lift > .02 ? '0 0 ' + Math.round(40 * lift) + 'px rgba(0,0,0,' + (.18 * lift).toFixed(3) + ')' : 'none';
  }
  function finish(done) {
    cancelAnimationFrame(raf);
    if (done) {
      if (dir > 0) fill(pl, 'l', target); else fill(pr, 'r', target);
      showSpread(target);
      syncRadio(target);
    } else {
      if (dir > 0) fill(pr, 'r', cur); else fill(pl, 'l', cur);
    }
    if (sheet) sheet.remove();
    sheet = null; dropL.style.opacity = 0; dropR.style.opacity = 0;
    bk.classList.remove('is-busy');
  }
  function animate(from, to, dur, cb) {
    if (REDUCED) { render(to); cb(); return; }
    var t0 = performance.now();
    var ease = function (t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
    var step = function (now) {
      var k = Math.min(1, (now - t0) / dur);
      render(from + (to - from) * ease(k));
      if (k < 1) raf = requestAnimationFrame(step); else cb();
    };
    raf = requestAnimationFrame(step);
  }
  function flipTo(i) {
    if (i === cur || i < 0 || i >= N || sheet) return;
    buildSheet(i > cur ? 1 : -1, i);
    render(0);
    animate(0, 1, 900, function () { finish(true); });
  }

  var muting = false;
  function syncRadio(i) {
    muting = true;
    radios[i].checked = true;
    radios[i].dispatchEvent(new Event('change', { bubbles: true }));
    muting = false;
  }
  book.addEventListener('change', function (e) {
    if (muting || !mq.matches || !e.target.classList.contains('rrg__radio')) return;
    var i = radios.indexOf(e.target);
    if (i !== cur) flipTo(i);
  });
  btnNext.addEventListener('click', function () { flipTo(cur + 1); });
  btnPrev.addEventListener('click', function () { flipTo(cur - 1); });
  root.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight') { e.preventDefault(); flipTo(cur + 1); }
    if (e.key === 'ArrowLeft') { e.preventDefault(); flipTo(cur - 1); }
  });

  function drag(corner, d) {
    corner.addEventListener('pointerdown', function (e) {
      if (sheet) return;
      var to = cur + d;
      if (to < 0 || to >= N) return;
      e.preventDefault();
      corner.setPointerCapture(e.pointerId);
      root.classList.add('is-dragging');
      buildSheet(d, to);
      var rect = bk.getBoundingClientRect(), w = rect.width;
      var last = e.clientX, lastT = performance.now(), v = 0;
      var move = function (ev) {
        var x = ev.clientX - rect.left;
        var p = d > 0 ? (w - x) / w : x / w;
        p = Math.max(0, Math.min(1, p));
        var now = performance.now();
        v = (ev.clientX - last) / Math.max(1, now - lastT); last = ev.clientX; lastT = now;
        render(p);
      };
      var up = function () {
        corner.removeEventListener('pointermove', move);
        corner.removeEventListener('pointerup', up);
        corner.removeEventListener('pointercancel', up);
        root.classList.remove('is-dragging');
        var flick = d > 0 ? v < -0.4 : v > 0.4;
        var go = angle > .45 || flick;
        animate(angle, go ? 1 : 0, 420, function () { finish(go); });
      };
      corner.addEventListener('pointermove', move);
      corner.addEventListener('pointerup', up);
      corner.addEventListener('pointercancel', up);
      render(0.04);
    });
  }
  drag(cornerR, 1);
  drag(cornerL, -1);

  function setup() {
    if (mq.matches) {
      var ci = radios.findIndex(function (r) { return r.checked; });
      if (ci >= 0) cur = ci;
      book.classList.add('rrfb-on');
      measure();
      showSpread(cur);
    } else {
      book.classList.remove('rrfb-on');
      if (sheet) finish(false);
    }
  }
  showSpread(cur);
  setup();
  if (mq.addEventListener) mq.addEventListener('change', setup); else mq.addListener(setup);
  var rt = 0;
  window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(measure, 150); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
})();
